import { LoadingSpinner } from "@eventr/common-storybook";
import { Stack } from "@mui/material";

interface AppLoadingSpinnerProps {
  staticType?: boolean;
}

export default function AppLoadingSpinner({ staticType }: AppLoadingSpinnerProps) {
  return (
    <Stack
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <LoadingSpinner size="32px" type={staticType ? "static" : undefined} />
    </Stack>
  );
}
